var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ActionType } from "@domains/features/Markets/OTC/entities/BookMark";
import { useState } from "react";
import otcDi from "../../../../mainDi/features/OTC/servicelocator";
import { useSelector } from "react-redux";
import actions from "@redux/feature/Markets/NCD/actions/ProductBouquetActions";
import transactionJourneyActions from "@redux/feature/Markets/NCD/actions/TransactionJourneyActions";
import { EBuySellFlag } from "@domains/features/Markets/OTC/entities/CashFlow";
import { tabMap } from "@domains/features/Markets/OTC/mapper/ProducyTabsMapper";
export var useTableHandler = function (subCategoryId, isSaveProduct, allTabPage) {
    var cActions = new actions();
    var cTransactionJourneyActions = new transactionJourneyActions();
    var _a = useSelector(function (state) { return state.markets.Otc.productBouquetReducer; }), watchListRequestPayload = _a.watchListRequestPayload, watchListSchemes = _a.watchListSchemes, bookMarkList = _a.bookMarkList;
    var _b = __read(useState(false), 2), showToast = _b[0], setShowToast = _b[1];
    var _c = __read(useState({
        isError: false,
        msg: "",
    }), 2), toastDetails = _c[0], setToastDetails = _c[1];
    var _d = __read(useState(false), 2), openViewDetails = _d[0], setOpenViewDetails = _d[1];
    var handleBookmark = function (isinIds, actionType, options) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, request, response, bookmarkedIds_1, filteredItems, request, response, filteredObject, request, response, error_1;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        return __generator(this, function (_m) {
            switch (_m.label) {
                case 0:
                    _m.trys.push([0, 10, , 11]);
                    _a = actionType;
                    switch (_a) {
                        case ActionType.INSERT: return [3 /*break*/, 1];
                        case ActionType.DELETE: return [3 /*break*/, 6];
                    }
                    return [3 /*break*/, 8];
                case 1:
                    if (!(options === null || options === void 0 ? void 0 : options.isMultiple)) return [3 /*break*/, 3];
                    request = isinIds.map(function (id) { return ({
                        category_code: Number(subCategoryId),
                        isin_id: Number(id),
                        action_type: isSaveProduct ? ActionType.DELETE : actionType,
                        buy_sell_flag: isSaveProduct
                            ? (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                                ? EBuySellFlag.BUY
                                : EBuySellFlag.SELL
                            : (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                                ? EBuySellFlag.BUY
                                : EBuySellFlag.SELL,
                        order_source: "web",
                    }); });
                    return [4 /*yield*/, otcDi.productBouquet.multiUpdateBookMark(request)];
                case 2:
                    response = _m.sent();
                    if (((_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.status) === "SUCCESS") {
                        if (isSaveProduct) {
                            setToastDetails({
                                isError: false,
                                msg: "Bookmark removed successfully!",
                            });
                            setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0: return [4 /*yield*/, otcDi.productBouquet.getBookMarkList(__assign(__assign({}, watchListRequestPayload), { category_code: Number(subCategoryId), tab_id: (_a = tabMap[String(subCategoryId)]) === null || _a === void 0 ? void 0 : _a[EBuySellFlag.SELL] }))];
                                        case 1:
                                            _b.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, 0);
                        }
                        else {
                            bookmarkedIds_1 = request === null || request === void 0 ? void 0 : request.map(function (item) { return item.isin_id; });
                            filteredItems = (_d = watchListSchemes === null || watchListSchemes === void 0 ? void 0 : watchListSchemes.data) === null || _d === void 0 ? void 0 : _d.filter(function (item) { return bookmarkedIds_1.includes(Number(item.isin_id)); });
                            cActions.getBookMark(__assign(__assign({}, bookMarkList), { data: __spreadArray(__spreadArray([], __read(bookMarkList === null || bookMarkList === void 0 ? void 0 : bookMarkList.data), false), __read(filteredItems), false) }));
                            setToastDetails({
                                isError: false,
                                msg: "Bookmark Saved successfully!",
                            });
                        }
                    }
                    else {
                        setToastDetails({
                            isError: false,
                            msg: (_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.message,
                        });
                    }
                    return [3 /*break*/, 5];
                case 3:
                    request = {
                        isin_id: Number(isinIds[0]),
                        category_code: Number(subCategoryId),
                        action_type: actionType,
                        buy_sell_flag: (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                            ? EBuySellFlag.BUY
                            : EBuySellFlag.SELL,
                        order_source: "web",
                    };
                    return [4 /*yield*/, otcDi.productBouquet.updateBookMark(request)];
                case 4:
                    response = _m.sent();
                    if (((_g = response === null || response === void 0 ? void 0 : response.data) === null || _g === void 0 ? void 0 : _g.status) === "SUCCESS") {
                        filteredObject = (_h = watchListSchemes === null || watchListSchemes === void 0 ? void 0 : watchListSchemes.data) === null || _h === void 0 ? void 0 : _h.find(function (item) { return (item === null || item === void 0 ? void 0 : item.isin_id) === isinIds[0]; });
                        cActions.getBookMark(__assign(__assign({}, bookMarkList), { data: __spreadArray(__spreadArray([], __read(bookMarkList === null || bookMarkList === void 0 ? void 0 : bookMarkList.data), false), [filteredObject], false) }));
                    }
                    setToastDetails({
                        isError: false,
                        msg: ((_j = response === null || response === void 0 ? void 0 : response.data) === null || _j === void 0 ? void 0 : _j.message) || "Bookmark Save successfully!",
                    });
                    _m.label = 5;
                case 5: return [3 /*break*/, 9];
                case 6:
                    request = {
                        isin_id: Number(isinIds[0]),
                        category_code: Number(subCategoryId),
                        action_type: actionType,
                        buy_sell_flag: (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                            ? EBuySellFlag.BUY
                            : EBuySellFlag.SELL,
                        order_source: "web",
                    };
                    return [4 /*yield*/, otcDi.productBouquet.updateBookMark(request)];
                case 7:
                    response = _m.sent();
                    if (((_k = response === null || response === void 0 ? void 0 : response.data) === null || _k === void 0 ? void 0 : _k.status) === "SUCCESS") {
                        cActions.getBookMark(__assign(__assign({}, bookMarkList), { data: (_l = bookMarkList === null || bookMarkList === void 0 ? void 0 : bookMarkList.data) === null || _l === void 0 ? void 0 : _l.filter(function (item) { return !isinIds.includes(String(item === null || item === void 0 ? void 0 : item.isin_id)); }) }));
                        setToastDetails({
                            isError: false,
                            msg: "Bookmark removed successfully!",
                        });
                        if (isSaveProduct) {
                            setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0: return [4 /*yield*/, otcDi.productBouquet.getBookMarkList(__assign(__assign({}, watchListRequestPayload), { category_code: Number(subCategoryId), tab_id: (_a = tabMap[String(subCategoryId)]) === null || _a === void 0 ? void 0 : _a[EBuySellFlag.SELL] }))];
                                        case 1:
                                            _b.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, 0);
                        }
                    }
                    return [3 /*break*/, 9];
                case 8:
                    console.warn("Invalid action type.");
                    return [2 /*return*/];
                case 9:
                    setShowToast(true);
                    return [3 /*break*/, 11];
                case 10:
                    error_1 = _m.sent();
                    setToastDetails({
                        isError: true,
                        msg: actionType === ActionType.DELETE
                            ? "Failed to remove Bookmark!"
                            : "Failed to save Bookmark!",
                    });
                    setShowToast(true);
                    return [3 /*break*/, 11];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    var handleRowClick = function (data) {
        var _a;
        setOpenViewDetails(true);
        var tableRowData = {
            ncdName: data === null || data === void 0 ? void 0 : data.display_name,
            isin: data === null || data === void 0 ? void 0 : data.isin_code,
            rating: data === null || data === void 0 ? void 0 : data.rating,
            payoutFreq: data === null || data === void 0 ? void 0 : data.interest_frequency,
            priceRange: data === null || data === void 0 ? void 0 : data.price_range,
            availableQty: data === null || data === void 0 ? void 0 : data.avl_qty,
            couponRate: data === null || data === void 0 ? void 0 : data.coupon_rate,
            isin_id: data === null || data === void 0 ? void 0 : data.isin_id,
            min_sell_price: String(data === null || data === void 0 ? void 0 : data.min_sell_price),
            dirty_price: Number(data === null || data === void 0 ? void 0 : data.min_sell_price),
            max_sell_price: String(data === null || data === void 0 ? void 0 : data.max_sell_price),
            buySellFlag: watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg,
            entity: data === null || data === void 0 ? void 0 : data.entity_name,
        };
        cTransactionJourneyActions.updateTransactionDetails(tableRowData);
        if (allTabPage) {
            cActions.updateSubCategoryId(String(data === null || data === void 0 ? void 0 : data.category_code));
            otcDi.productBouquet.getProductDetails({
                isin_code: data === null || data === void 0 ? void 0 : data.isin_code,
                tab_id: (_a = tabMap[String(subCategoryId)]) === null || _a === void 0 ? void 0 : _a[EBuySellFlag.SELL],
                buysell_flg: (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                    ? EBuySellFlag.BUY
                    : EBuySellFlag.SELL,
            });
        }
        else {
            otcDi.productBouquet.getProductDetails({
                isin_code: data === null || data === void 0 ? void 0 : data.isin_code,
                tab_id: watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.tab_id,
                buysell_flg: (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                    ? EBuySellFlag.BUY
                    : EBuySellFlag.SELL,
            });
        }
    };
    return {
        showToast: showToast,
        toastDetails: toastDetails,
        openViewDetails: openViewDetails,
        setOpenViewDetails: setOpenViewDetails,
        handleBookmark: handleBookmark,
        handleRowClick: handleRowClick,
        setShowToast: setShowToast,
    };
};
